<template>
  <div id="app">
    <VaColorPicker
      class="color-picker"
      title="Buttons color"
      position="bottom"
      v-model="form.primaryColor"></VaColorPicker>
    <div class="button-options-wrapper" v-for="(button, index) in form.buttons" :key="index">
      <div class="options-title">{{ button.title }}</div>
      <v-select
        v-model="button.type"
        persistent-placeholder
        hide-details
        label="Button type"
        placeholder="Select type"
        :items="buttonTypes">
        <template v-slot:append>
          <v-icon>mdi-chevron-down</v-icon>
        </template>
      </v-select>
      <v-text-field
        class="spacing-top--16"
        v-if="button.type === 'url'"
        v-model="button.url"
        persistent-placeholder
        hide-details
        placeholder="https://domain.com"
        label="URL"></v-text-field>
      <v-select
        class="spacing-top--16"
        v-if="button.type === 'url'"
        v-model="button.openIn"
        persistent-placeholder
        hide-details
        label="Open link in..."
        :items="linkTypes">
        <template v-slot:append>
          <v-icon>mdi-chevron-down</v-icon>
        </template>
      </v-select>
      <VaColorPicker
        v-if="button.type === 'textBox'"
        class="spacing-top--16"
        title="Text-box background color"
        :position="index === 0 ? 'bottom' : 'top'"
        v-model="button.textBgColor"></VaColorPicker>
      <VaColorPicker
        v-if="button.type === 'textBox'"
        class="spacing-top--16"
        title="Text-box border color"
        :position="index === 0 ? 'bottom' : 'top'"
        v-model="button.textBorderColor"></VaColorPicker>
    </div>
  </div>
</template>
<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  export default {
    components: { VaColorPicker },
    data() {
      return {
        form: {
          primaryColor: "#28B02B",
          buttons: [
            {
              title: "First button",
              openIn: "_self",
              textBgColor: "#EBEBEB",
              textBorderColor: "#A5A5A5",
              text: "Yes",
            },
            {
              title: "Second button",
              openIn: "_self",
              textBgColor: "#EBEBEB",
              textBorderColor: "#A5A5A5",
              text: "No",
            },
          ],
        },
        buttonTypes: [
          { text: "URL", value: "url" },
          { text: "Text box", value: "textBox" },
        ],
        linkTypes: [
          { text: "Same window tab", value: "_self" },
          { text: "New window tab", value: "_blank" },
        ],
        dialog: false,
        text: "",
      };
    },
    beforeMount() {
      document.documentElement.style.overflowY = "auto";
    },
    watch: {
      form: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
    },
    methods: {
      updateValue(val) {
        window.parent.postMessage(
          {
            mceAction: "updateData",
            data: val,
          },
          origin,
        );
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  html {
    overflow-y: auto;
  }

  .color-picker {
    margin-bottom: 16px;
  }

  .button-options-wrapper {
    border: 1px solid get-color("border");
    background: get-color("hover");
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 16px;

    .options-title {
      @include text-caption();
      color: get-color("subtitle");
      margin-bottom: 16px;
    }
  }

  #app {
    padding: 10px;
  }
</style>
